import React, { memo, useCallback } from 'react'

import {
  Button,
  Icon,
  Download2,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { triggerExport } from 'Pods/ThreeDStudio/Store/actions/export'
import { isExportInFlightForCurrentView } from 'Pods/ThreeDStudio/Store/slices/export'

const downloadIcon = <Icon svgComponent={Download2} color="dark" size={iconSize} notSpaced />

function ExportButton() {
  const selectedFormat = useThreeDStudioStore(state => state.export.selectedFormat)
  const isInFlightForCurrentView = useThreeDStudioStore(isExportInFlightForCurrentView)
  const assetId = useThreeDStudioStore(state => state.viewer.inputThreeD)

  const isDisabled = !assetId || isInFlightForCurrentView

  const handleExportClick = useCallback(() => {
    if (isDisabled) return
    triggerExport(assetId, selectedFormat)
  }, [isDisabled, assetId, selectedFormat])

  return (
    <Button
      icon={downloadIcon}
      type="secondary"
      size="small"
      variant="with-icon"
      aria-label="Export"
      disabled={isDisabled}
      onClick={handleExportClick}
      customClass="export-cluster__export"
    >
      Export
    </Button>
  )
}

export default memo(ExportButton)
